/**
 * FeedbackSidebarNavigationItemButton
 */
import * as React from 'react';
import { connect } from 'react-redux';

// Actions
import { updateQueryString } from '../../../../../../services/router/actions';
import { dispatchClickEvent } from '../../../../../../services/googleTagManager/actions';

// Components
import SidebarNavigationItemButton from '../SidebarNavigationItemButton';

interface Props {
    updateQueryString: Function;
    dispatchClickEvent: Function;
}

export class FeedbackSidebarNavigationItemButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.dispatchClickEvent('User Feedback Button'); // Fires tag manager
        this.props.updateQueryString({
            feedbackModal: true
        });
    };

    render() {
        return (
            <SidebarNavigationItemButton
                onClick={this.handleClick}
                title="Feedback"
                iconName="FiFileText"
            />
        );
    }
}

export default connect(
    null,
    { updateQueryString, dispatchClickEvent }
)(FeedbackSidebarNavigationItemButton);
